module.exports = __webpack_public_path__ + "static/media/82.79d3b848.png";